import { render, staticRenderFns } from "./UserExchangeAgreement.vue?vue&type=template&id=5b2d5660"
import script from "./UserExchangeAgreement.vue?vue&type=script&lang=js"
export * from "./UserExchangeAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports